import React from 'react';
import { withStyles, Typography } from './../../../themes/default';
import { Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from './../../../themes/dialog';
import { Btn } from './../../../components/includes/ui';

const styles = theme => ({
  content: { paddingTop: theme.spacing.unit * 3 }
});

const Confirm = ({ classes, status, title, message, cancel, confirm, handleConfirmDeleteUserCancel, ...rest}) => {

  return (
    <Dialog
        open={ status }
        onClose={ handleConfirmDeleteUserCancel }
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description">

      { title && (
        <DialogTitle>
          <Typography component="p" variant="title" align="center">
            { title }
          </Typography>
        </DialogTitle>
      )}

      <DialogContent className={ classes.content }>
        <DialogContentText id="alert-dialog-slide-description">
          { message }
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <span>
          <Btn aria-label="Cancelar" color="secondary" onClick={ cancel }>
              Cancelar
          </Btn>
        </span>
        <span>
          <Btn aria-label="Confirmar" onClick={ confirm } color="danger">
            Confirmar
          </Btn>
        </span>
      </DialogActions>

    </Dialog>
  )

}

export default withStyles(styles)(Confirm);
